import * as React from 'react'

function SvgRemove(props) {
  return (
    <svg
      height="1em"
      viewBox="0 0 100 100"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.664 39.215h66.908a2 2 0 012 2v16.101a2 2 0 01-2 2H16.664a2 2 0 01-2-2V41.215a2 2 0 012-2z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default SvgRemove
